




import { AUTH_LOADING, AUTH_LOGIN, AUTH_LOGOUT,SAVEDATA } from "./login.actionTypes";


export const login = ({name,email}) =>  (dispatch) => {

    dispatch({ type: AUTH_LOADING });
   
            dispatch({ type: AUTH_LOGIN, payload: {name,email} });
           
      



}

export const savedata=(data)=>(dispatch)=>{
   
    dispatch({type:SAVEDATA,payload:data})

}



